/**
 * Aciona o download de um arquivo criando um elemento âncora temporário
 * @param url - A URL do arquivo para download
 */
export function downloadFile(url: string): void {
  const link = document.createElement('a');
  link.href = url;
  link.download = '';
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
}

/**
 * Cria um atraso usando Promise
 * @param ms - Milissegundos para atrasar
 */
export function delay(ms: number): Promise<void> {
  return new Promise(resolve => setTimeout(resolve, ms));
}
